import { render, staticRenderFns } from "./payment-logs-tab.vue?vue&type=template&id=63ebcba8&scoped=true"
import script from "./payment-logs-tab.vue?vue&type=script&lang=js"
export * from "./payment-logs-tab.vue?vue&type=script&lang=js"
import style0 from "./payment-logs-tab.vue?vue&type=style&index=0&id=63ebcba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ebcba8",
  null
  
)

export default component.exports